import {
	createExpandedRowModel,
	createFilteredRowModel,
	createPaginatedRowModel,
	stockFeatures,
	tableFeatures,
} from "@tanstack/react-table";

export const cargoTableFeatures = tableFeatures({
	...stockFeatures,
	expandedRowModel: createExpandedRowModel(),
	filteredRowModel: createFilteredRowModel(),
	paginatedRowModel: createPaginatedRowModel(),
});
